import { updateObject } from 'utils/updateObject'
import { LOGOUT } from 'modules/Auth/types'
import {
  SET_APP_DATA,
  SET_TICKETS_COUNTER,
  SET_USER_INFO,
} from 'modules/App/types'

const reg = new RegExp(/(?:\/)(en|ru|cn)(?:\/)/)

const initialState = {
  ticketsCounter: undefined,
  user: {
    balance: { amount: 0, currency: 'RUB' },
  },
  masterUser: null,
  token: null,
  error: null,
  loading: false,
  i18n: global.location.pathname.match(reg)
    ? global.location.pathname.match(reg)[1]
    : 'ru',
  providers: [
    'vk',
    //'instagram',
    'telegram',
    'ok',
    'twitter',
    'facebook',
  ],
}

const setAppData = (state, action) => updateObject(state, action.payload)
const dropUserData = (state) =>
  updateObject(state, {
    ...initialState,
  })

const setTicketCounter = (state, { payload }) =>
  updateObject(state, {
    ticketsCounter: payload,
  })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_INFO:
    case SET_APP_DATA:
      return setAppData(state, action)
    case SET_TICKETS_COUNTER:
      return setTicketCounter(state, action)
    case LOGOUT:
      return dropUserData(state)
    default:
      return state
  }
}
export default reducer
